<template>
    <div>
        <div class="top">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>账户概览</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="page-content p20">
            <div class="box p20 bg_fff">
                <h2>我要提现</h2>
                <div class="tit"><p class="money" style="font-size: 18px;padding: 10px 0;">余额： <span style="font-weight: bold; color: #f00;">{{userinfo.balance}}</span>元 </p> <el-button type="text" @click="setAll">全部提现</el-button></div>
                <div class="input-box"><span class="unit">&yen;</span><mu-text-field v-model="form.money"></mu-text-field><span>（提现手续费为0元）</span></div>
                <div class="tip">
                    <p>
                        提现说明：提现申请成功后，1-3个工作日内可到账;<br>
                        单笔最低提现金额100元，最高提现不超过10万元，提现到个人微信最高50000元/笔<br>
                    </p>
                </div>
                <div class="card">
                    <p class="name" style="font-size: 20px;font-weight: bold;">提现账号</p>
                    <p><span style="color:#000;font-weight: bold;">微信账号：</span><span v-if="userinfo.wx" style="margin-right: 20px;">{{userinfo.wx}}</span><span v-else style="margin-right: 20px;color: #999999;">您还未绑定账号，请绑定后再申请</span><el-button type="text" @click="bandWx">账号设置</el-button></p>
                </div>
                <div class="d_flex">
                    <el-button @click="back" style="margin-right: 20px;">返回</el-button>
                    <el-button @click="subApply" type="primary" v-if="userinfo.wx">提交申请</el-button>
                </div>
            </div>
        </div>
        <el-dialog
                title="绑定账号"
                :visible.sync="bandPop"
                width="500px"
                style="text-align: left"
        >
            <div class="pop-box">
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="手机号">
                        <el-input type="input" v-model="mobile" maxlength="11" placeholder="请输入手机号" style="margin-bottom:20px ;"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码">
                        <el-input type="input" v-model="code" maxlength="30" placeholder="请输入验证码" style="margin-bottom:20px ;"><template slot="append" ><div @click="getCode" style="cursor: pointer">{{count==0?'获取验证码':'重新获取('+count+'s)'}}</div></template></el-input>
                    </el-form-item>
                    <el-form-item label="微信号">
                        <el-input type="input" v-model="wxCode" maxlength="30" placeholder="请输入微信号" style="margin-bottom:20px ;"></el-input>
                    </el-form-item>
                </el-form>
                <div class="btn-box">
                    <el-button  @click="bandPop=false">取消</el-button>
                    <el-button type="primary" @click="subWx">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {getCode,bandWx,addBank} from '../../api/index'
    import {getUserinfo} from '../../api/role'
    export default {
        name: "apply",
        data(){
            return{
                form:{
                    money:''
                },
                title:'获取验证码',
                timer:'',
                count: '',//验证码倒计时
                isClick:true,
                userinfo:'',
                wxCode:'',
                mobile:'',
                code:'',
                bandPop:false
            }
        },
        mounted(){
            this.getUserinfo();
        },
        methods:{
            back(){
                this.$router.push({path:'/withdraw/withdraw'})
            },
            bandWx(){
                this.bandPop=true;
            },
            getCode(){
                if(!this.isClick){
                    return;
                }
                if(!/^[1][0-9]{10}$/.test(this.mobile)){
                    this.$message.error('请输入正确的手机号');
                    return;
                }
                getCode({
                    mobile:this.mobile
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('验证码发送成功');
                        this.isClick=false;
                        const TIME_COUNT = 60;
                        if (!this.timer) {
                            this.count = TIME_COUNT;
                            this.timer = setInterval(() => {
                                if (this.count > 0 && this.count <= TIME_COUNT) {
                                    this.count--;
                                } else {
                                    clearInterval(this.timer);
                                    this.timer = null;
                                    this.isClick=true;
                                }
                            }, 1000)
                        }

                    }else{
                        this.$message.error(res.msg);
                    }
                })
            },
            subWx(){
                if(!/^[1][0-9]{10}$/.test(this.mobile)){
                    this.$message.error('请输入正确的手机号');
                    return;
                }
                if(!this.code){
                    this.$message.error('请输入验证码');
                    return;
                }
                if(!this.wxCode){
                    this.$message.error('请输入微信号');
                    return;
                }
                bandWx({
                    code:this.code,
                    mobile:this.mobile,
                    wx:this.wxCode
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('绑定成功');
                        this.bandPop=false;
                        this.getUserinfo();
                    }else{
                        this.$message.error(res.msg);
                    }
                })

            },
            getUserinfo(){
                getUserinfo().then(res=>{
                    if(res.code==1){
                        this.userinfo=res.data;
                        this.mobile=this.userinfo.mobile;
                    }
                })
            },
            setAll(){
                this.form.money=this.userinfo.balance;
            },
            subApply(){
                if(this.userinfo.balance){
                    this.$alert('您的可提现金额不足，暂不能申请提现', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {

                        }
                    });
                    return;
                }
                if(this.form.money<0){
                    this.$alert('请输入提现金额', '提示', {
                        confirmButtonText: '确定',
                        callback: action => {

                        }
                    });
                    return;
                }
                addBank({
                    money:this.form.money
                }).then(res=>{
                    if(res.code==1){
                        this.$message.success('提交成功');
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .top{
        padding: 20px 0 0 20px;
    }
    .box{
        text-align: left;
    }
</style>

